import React from 'react';

//helpers
import { checkValue } from 'src/components/common/helper';
import { get } from 'lodash';
import HotelsHotelWidget from 'src/components/common/SearchWizard/shareduiwizard/Lodging/hotels/hotelWidget';

import { useWindowDimensions } from 'src/components/common/useWindowDimentions';
//types
import { HeroSearchWizardProps } from '../../typings';

const HeroSearchWizard: React.FC<HeroSearchWizardProps> = (props) => {
  const { heroSearchWizData, wizardLocalization, mccidData  } = props;

  const { width: windowWidth } = useWindowDimensions();

  let wizardTabs =
    checkValue(get(heroSearchWizData, 'wizardTabs', [])) && get(heroSearchWizData, 'wizardTabs', []).length > 0
      ? get(heroSearchWizData, 'wizardTabs', [])
      : [];

  wizardTabs = wizardTabs?.filter((tab: string) => tab?.toLowerCase() === 'hotel');

  if (wizardTabs?.length > 0) {
    return (
      <div
        className={`hero-searchwizard-component
            ${windowWidth < 576 ? 'apply-bottom' : ''}
        `}
      >
        <HotelsHotelWidget
          data={{ ...heroSearchWizData }}
          wizardLocalization={wizardLocalization}
          mccidData={
            ...mccidData
          }
        />
      </div>
    );
  } else {
    return null;
  }
};

export default HeroSearchWizard;
